
import AppSwiper from "../../components/common/AppSwiper/AppSwiper";
import ArticleCard from "../../pages/Articles/ArticleCard/ArticleCard";
import "./ArticleGrid.css";

export default function ArticleGrid({
    articles = [],  
    showTitle = true,
}) {
    if (!articles.length) {
        return null;
    }



    return (
        <section className="article-grid-section">

       


            {/* Desktop / Tablet */}

            <div className="article-grid article-grid--desktop">

                {articles.map((article) => (
                    <ArticleCard
                        key={article.id}
                        article={article}
                    />
                ))}

             

            </div>




            {/* Mobile */}

            <div className="article-grid article-grid--mobile">

                <AppSwiper
                    slidesPerView={1.15}
                    spaceBetween={12}
                    navigation={false}
                    pagination={true}
                    loop={false}
                    className="article-grid-swiper"
                >

                    {articles.map((article) => (
                        <ArticleCard
                            key={article.id}
                            article={article}
                        />
                    ))}

                </AppSwiper>

            </div>

        </section>
    );
}